/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Quotas_Over_Budget_Raise_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not raise the total budget." |
*
* @param {Sub_Quotas_Over_Budget_Raise_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_over_budget_raise_error = /** @type {((inputs?: Sub_Quotas_Over_Budget_Raise_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Over_Budget_Raise_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesamtbudget konnte nicht erhöht werden.")
	return /** @type {LocalizedString} */ ("Could not raise the total budget.")
});